import { useCallback } from 'react';
import { UserAcknowledgementType } from '../../common';
import { selectUserAcknowledgementTypes, selectUserAcknowledgements, useAppInitStore } from '../../stores';

export const useUserAcknowledgements = () => {
	const userAcknowledgements = useAppInitStore(selectUserAcknowledgements);
	const userAcknowledgementTypes = useAppInitStore(selectUserAcknowledgementTypes);

	const getUserAcknowledgementsByTypeName = useCallback(
		(userAcknowledgementType: UserAcknowledgementType) => {
			const acknowledgementTypeId = userAcknowledgementTypes?.find((t) => t.name === userAcknowledgementType)?.id;

			return userAcknowledgements?.find((u) => u.userAcknowledgementTypeId === acknowledgementTypeId);
		},
		[userAcknowledgementTypes, userAcknowledgements]
	);

	return { userAcknowledgements, userAcknowledgementTypes, getUserAcknowledgementsByTypeName };
};
